import { PROTECTED_PATHS } from "../../app/constants";
import { RiCameraLensLine, RiAdvertisementLine } from "react-icons/ri";
import { BiWallet } from "react-icons/bi";
import { BsHouse, BsGear, BsPeople, BsShop } from "react-icons/bs";
import { IoIosNotificationsOutline, IoMdPersonAdd } from "react-icons/io";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { VscPerson } from "react-icons/vsc";
import { FaRegIdCard, FaShopify,FaPeopleArrows } from "react-icons/fa";
import { MdHowToVote } from "react-icons/md";
import { FiShoppingCart } from "react-icons/fi";
import { TbBrandGoogleAnalytics } from "react-icons/tb";
import { AiOutlineCheckSquare } from "react-icons/ai";
import { MdOutlineVideoLibrary } from "react-icons/md";
import { ImUsers } from "react-icons/im";
import { GrArtist } from "react-icons/gr";

import { MdOutlineSlowMotionVideo } from "react-icons/md";

export const NAV_ITEMS = [
  {
    title: "Home",
    to: PROTECTED_PATHS.MY_ESTATE,
    icon: <BsHouse size={20} />,
  },
  {
    title: "Guests",
    icon: <ImUsers size={20} />,
    children: [
      {
        title: "Invite Guest",
        to: PROTECTED_PATHS.INVITE_GUEST,
        icon: <IoMdPersonAdd size={20} />,
      },
      {
        title: "Guest Log",
        to: PROTECTED_PATHS.GUEST_LIST,
        icon: <VscPerson size={20} />,
      },
      {
        title: 'Checkout Items',
        to: PROTECTED_PATHS.GATE_ITEM_PASS,
        icon: <FaPeopleArrows size={18} />,
      }
    ]
  },
  {
    title: "Special Requests",
    to: PROTECTED_PATHS.SPECIAL_GUEST_REQUEST,
    icon: <BsPeople size={22} />,
  },
  {
    title: "Market Place",
    icon: <BsShop size={20} />,
    children: [
      {
        title: "Marketplace",
        to: PROTECTED_PATHS.MARKET_PLACE,
        icon: <FiShoppingCart size={20} />,
      },
      {
        title: "Food Listings",
        to: PROTECTED_PATHS.FOOD_LISTINGS,
        icon: <FiShoppingCart size={20} />,
      },
      {
        title: "My Shop",
        to: PROTECTED_PATHS.SHOP,
        icon: <FaShopify size={20} />,
      }
    ]
  },
  {
    title: "Artisans",
    to: PROTECTED_PATHS.ARTISAN_PAGE,
    icon: <BsPeople size={20} />,
  },
  {
    title: "Access Card",
    to: PROTECTED_PATHS.ID_CARD,
    icon: <FaRegIdCard size={20} />,
  },
  {
    title: "Finance",
    icon: <BsShop size={20} />,
    children: [
      {
        title: "Billing Analysis",
        to: PROTECTED_PATHS.BILLING_ANALYSIS,
        icon: <TbBrandGoogleAnalytics size={22} />,
      },
      {
        title: "Estate Bill(s)",
        to: PROTECTED_PATHS.ESTATE_BILLS,
        icon: <FaShopify size={20} />,
      }
    ]
  },
  {
    title: "Polls",
    to: PROTECTED_PATHS.POLLS,
    icon: <MdHowToVote size={20} />,
  },
  {
    title: "Support",
    icon: <IoChatboxEllipsesOutline size={20} />,
    children: [
      {
        title: "How to Videos",
    to: PROTECTED_PATHS.VIDEO,
    icon: <MdOutlineSlowMotionVideo size={22}/>
      },
      {
        title: "Issue Report",
        to: PROTECTED_PATHS.ISSUE_REPORT,
        icon: <RiCameraLensLine size={20} />,
      },
      {
        title: "Chat with Us",
        to: PROTECTED_PATHS.CHAT,
        externalLink: "https://chat.usegerant.com/index.php?p=link&sp=3&ssp=en",
        icon: <IoChatboxEllipsesOutline size={20} />,
      }
    ]
  },
  {
    title: "Notifications",
    to: PROTECTED_PATHS.NOTIFICATIONS,
    icon: <IoIosNotificationsOutline size={22} />,
  },
  {
    title: "Family Member",
    to: PROTECTED_PATHS.FAMILY_MEMBERS,
    icon: <ImUsers size={20} />,
  },
  {
    title: "Settings",
    to: PROTECTED_PATHS.SETTINGS,
    icon: <BsGear size={20} />,
  },
];